export default __webpack_public_path__ + "static/media/eyeofjudgment.4e0e2f63.png";